import React from 'react';
import MinusIcon from '@heroicons/react/20/solid/MinusIcon';
import { S2Checkbox } from 'apps/sigma2-ui/src/components/ui/Checkbox';

export interface SelectAllCheckboxProps {
  checked: boolean;
  children: React.ReactNode;
  onChange: (params: { allChecked: boolean }) => void;
}

export const SelectAllCheckbox: React.FC<SelectAllCheckboxProps> = ({
  checked,
  children,
  onChange,
}) => {
  if (checked) {
    return (
      <label className="flex space-x-2 items-center font-sans cursor-pointer">
        <MinusIcon
          className="h-4 w-4 text-white bg-gray-900 rounded-sm"
          aria-hidden="true"
        />

        <input
          type="checkbox"
          checked={checked}
          onChange={() => {
            onChange({ allChecked: false });
          }}
          className="form-input hidden"
        />

        <span>{children}</span>
      </label>
    );
  }

  return (
    <S2Checkbox
      onChange={() => {
        onChange({ allChecked: true });
      }}
      checked={false}
    >
      {children}
    </S2Checkbox>
  );
};
